<template>
  <b-row class="yes-no-preference-input">
    <b-col
      cols="12"
      class="d-flex ml-3"
    >
      <b-form-radio-group
        stacked
        class="text-left v3_control_radio_group"
        :checked="checkedValue"
        @change="onChangeHandler"
      >
        <b-form-radio :value="1" class="my-2">
          Yes
        </b-form-radio>
        <b-form-radio :value="0" class="my-2">
          No
        </b-form-radio>
      </b-form-radio-group>
    </b-col>
  </b-row>
</template>

<script>
import { validationMixin } from 'vuelidate';
import SubFormValidationMethodsMixin from '@/mixins/SubFormValidationMethodsMixin';

export default {
  name: 'YesNoPreferenceInput',
  mixins: [validationMixin, SubFormValidationMethodsMixin],
  props: {
    jobQuestion: {
      required: true,
    },
    forQuestionForm: {
      type: Boolean,
      default: false,
    },
  },
  validations: {
    selected: {},
  },
  computed: {
    checkedValue: function () {
      const variable = this.jobQuestion.jobQuestionVariables[0];
      const response = variable
        ? (variable.jobProfileQuestionResponses || [])[0]
        : null;
      return (response || {}).value;
    },
  },
  methods: {
    onChangeHandler: function (checkedValue) {
      this.$emit('set-preference', checkedValue);
      this.$v.selected.$touch();
    },
  },
};
</script>
